import { DELETED_ITEMS } from "@const/timeseriesRequest.contants";
import { DeletedItems } from "@dto/timeseriesRequest.dto";
import { ModalFuncProps, Radio, Space } from "antd";
import { FC, useState } from "react";
import { XmModal } from "src/component/modal/XmModal";
import { GLOB } from "src/util/Glob";

interface DeletedItemsModalState extends ModalFuncProps {
  deleted: DeletedItems;
  onConfirm: (deleted: DeletedItems) => Promise<void>;
  onCancel: () => void;
}

export const DeletedItemsModal: FC<DeletedItemsModalState> = ({ deleted, onConfirm, onCancel, ...props }) => {
  const [deletedItems, setDeletedItems] = useState<DeletedItems>(deleted || (GLOB.showDeletedItems ? 'compact' : 'hide'));

  return <XmModal width={400} title="Show deleted items" destroyOnHidden
    onOk={() => onConfirm(deletedItems)}
    onCancel={() => onCancel()} {...props}>
    <Radio.Group onChange={e => setDeletedItems(e.target.value)} value={deletedItems}>
      <Space orientation="vertical">
        <Radio value={DELETED_ITEMS.hide}>Hide deleted</Radio>
        <Radio value={DELETED_ITEMS.compact}>Show deleted - compact</Radio>
        <Radio value={DELETED_ITEMS.show}>Show deleted - all items</Radio>
      </Space>
    </Radio.Group>
  </XmModal>;
};